import { Tag } from './tag';
// import { Reminder } from './reminder';

// 定义提醒动作类型 (映射 VALARM ACTION)
export type ReminderAction = 'DISPLAY' | 'AUDIO' | 'EMAIL';

// 定义提醒触发器关联点 (映射 VALARM TRIGGER RELATED - 扩展以区分 END 和 DUE)
export enum TriggerRelation {
  START = 'START',
  // END = 'END', // 不再直接使用 END，用下面两个代替
  CALCULATED_END = 'CALCULATED_END', // 基于 startAt + cost
  DUE = 'DUE'                   // 基于 dueAt
}

// 新的 Reminder 接口，基于 VALARM 核心概念
export interface Reminder {
  // VALARM ACTION (映射)
  action: ReminderAction;
  // VALARM TRIGGER 核心属性
  trigger: {
    // 触发类型：相对或绝对
    type: 'RELATIVE' | 'ABSOLUTE';
    // 相对触发相关
    related?: TriggerRelation; // 关联到 START 或 END/DUE
    offsetSeconds?: number;    // 相对偏移秒数 (正数表示之后, 负数表示之前)
    // 绝对触发相关
    absoluteTime?: string;     // ISO 8601 UTC 时间字符串 (e.g., "20250420T090000Z")
  };
  description?: string; // 提醒文本 (映射 VALARM DESCRIPTION/SUMMARY)
  // 提醒方式 (映射，可以根据 action 进一步细化)
  methods: ('短信' | '微信' | '邮件' | '桌面通知')[];
}

export interface Task {
  id: string;
  userId: string;
  title: string;
  notes: string;
  done: boolean;
  vital: boolean;
  urgent: boolean;
  fixed: boolean;
  dueAt?: string | null;  // VALARM TRIGGER RELATED=END 会关联到此
  startAt?: string | null; // VALARM TRIGGER RELATED=START 会关联到此
  cost?: number | null;    // 可用于计算 DTEND (DTSTART + cost)
  embedding: number[] | null;
  createdAt: string;
  updatedAt: string;
  projectId?: string | null;
  project?: {
    id: string;
    title: string;
  };
  doneAt?: string | null;
  recurrenceRule?: string | null;
  isHabit?: boolean;
  recurrenceGroupId?: string | null;
  tags?: Tag[];
  reminders?: Reminder[] | null;
}

export interface CreateTaskData {
  title: string;
  notes?: string;
  done?: boolean;
  vital?: boolean;
  urgent?: boolean;
  fixed?: boolean;
  dueAt?: string;
  startAt?: string;
  endAt?: string; // Virtual field, not stored directly but useful for UI/calculations
  cost?: number;
  reminders?: Reminder[];
  projectId?: string;
  recurrenceRule?: string;
  isHabit?: boolean;
  // recurrenceGroupId 由系统自动管理，前端不需要传递
}

export interface UpdateTaskData {
  id: string;
  title?: string;
  notes?: string;
  done?: boolean;
  vital?: boolean;
  urgent?: boolean;
  fixed?: boolean;
  dueAt?: string;
  startAt?: string;
  endAt?: string; // Virtual field
  cost?: number;
  reminders?: Reminder[];
  projectId?: string;
  recurrenceRule?: string;
  isHabit?: boolean;
  // recurrenceGroupId 由系统自动管理，前端不需要传递
}

export interface TaskSearchParams {
  keywords: string[];
}

// Helper types for time duration
export interface Duration {
  days: number;
  hours: number;
  minutes: number;
}

// Convert seconds to duration object
export const secondsToDuration = (seconds: number): Duration => {
  const days = Math.floor(seconds / (24 * 3600));
  const hours = Math.floor((seconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return { days, hours, minutes };
};

// Convert duration object to seconds
export const durationToSeconds = (duration: Duration): number => {
  return (
    duration.days * 24 * 3600 +
    duration.hours * 3600 +
    duration.minutes * 60
  );
};